import { getPath } from '@speeki/client-admin';
import { useCheckFlag } from '@speeki/feature-flags';

import {
    StatisticsCard,
    StatisticsCardProps,
} from '@components/molecules/StatisticsCards/StatisticsCard';

interface SurveysCardProps
    extends Pick<StatisticsCardProps, 'statistics' | 'hidden' | 'loading'> {}

export const SurveysCard = ({
    hidden,
    loading,
    statistics,
}: SurveysCardProps) => {
    const isEngagementFeature = useCheckFlag(
        'client_admin-stakeholder_engagement-20250312',
    );

    const cardTitle = isEngagementFeature ? 'Pulse Survey' : 'Surveys';
    const cardDescription = isEngagementFeature ? 'pulse surveys' : 'surveys';
    const buttonText = isEngagementFeature ? 'Pulse Surveys' : 'survey';

    return (
        <StatisticsCard
            actionLink={{
                href: getPath({
                    path: isEngagementFeature
                        ? '/engagement/pulse'
                        : '/survey/templates/create',
                }),
                text: `Go to ${buttonText}`,
            }}
            description={`Summary of ${cardDescription} statuses.`}
            hidden={hidden}
            loading={loading}
            statistics={statistics}
            title={cardTitle}
        />
    );
};
